export default "__VITE_ASSET__8xDiXl9k__"